import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '@/assets/images/logo.webp';
import { Menu, X, ChevronDown, ChevronRight } from 'lucide-react';
// import EnquiryModal from './contact-us/EnquiryModal';
import FloatingActionButton from '@/components/FloatingActionButton';
//import EnquiryModal from './contact-us/EnquiryModal';
import EnquiryModalPopup from '@/components/EnquiryModalPopup';

const Navbar = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [projectOpen, setProjectOpen] = useState(false);
  const [residentialOpen, setResidentialOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    propertyType: '',
    location: '',
    message: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const propertyTypes = ['Residential', 'Commercial', 'Industrial'];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePropertyTypeClick = (type) => {
    setFormData({ ...formData, propertyType: type });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.fullName || !formData.phone || !formData.email || !formData.propertyType) {
      setError('Please fill all required fields.');
      setSuccess('');
      return;
    }

    const payload = {
      full_name: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      property_type: formData.propertyType,
      location: formData.location,
      message: formData.message,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSuccess('Your enquiry has been submitted!');
        setError('');
        setFormData({
          fullName: '',
          phone: '',
          email: '',
          propertyType: '',
          location: '',
          message: '',
        });
        setTimeout(() => setModalOpen(false), 1500);
      } else {
        const errorData = await response.json();
        setError(errorData?.message || 'Something went wrong.');
        setSuccess('');
      }
    } catch (err) {
      setError('Failed to submit. Please try again later.');
      setSuccess('');
      console.error(err);
    }
  };

  const mainMenu = [
    { id: 'about', label: 'About', url: '/about-us' },
    {
      id: 'project',
      label: 'PROJECTS',
      dropdown: [
        {
          id: 'residential',
          label: 'Residential',
          url: '/residential-projects',
          subItems: [
            { id: 'residential-jaipur', label: 'Jaipur', url: '/residential-projects/jaipur' },
            { id: 'residential-mumbai', label: 'Mumbai', url: '/residential-projects/mumbai' },

          ]
        },
        { id: 'commercial', label: 'Commercial', url: '/commercial-project' },
        { id: 'luxury', label: 'Industrial', url: '/industrial-project' },
      ],
    },
    { id: 'connect', label: 'Connect', url: '/contact-us' },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setScrolled(window.scrollY > 50);
  }, [location.pathname]);

  const isActive = (id) => {
    const path = location.pathname.toLowerCase();
    switch (id) {
      case 'about': return path.includes('/about-us');
      case 'connect': return path.includes('/contact-us');
      case 'residential': return path.startsWith('/residential-projects');
      case 'residential-jaipur': return path.includes('/residential-projects/jaipur');
      case 'residential-mumbai': return path.includes('/residential-projects/mumbai');
      case 'commercial': return path.startsWith('/commercial-project');
      case 'luxury':
      case 'industrial': return path.startsWith('/industrial-project');
      case 'project':
        return (
          path.startsWith('/residential-projects') ||
          path.startsWith('/commercial-project') ||
          path.startsWith('/industrial-project')
        );
      default: return false;
    }
  };

  const headerHeight = scrolled ? 128 : 80;

  return (
    <>
      <header
        className={`fixed w-full z-50 transition-all duration-300`}
        // className={`fixed w-full z-50 transition-all duration-300 ${scrolled
        //   ? 'bg-gradient-to-r from-[#956325] to-[#c97a17]'
        //   : 'bg-main-holder bg-main-mobile'
        //   }`}
      >
        <div className="container-fluid py-2 flex items-center justify-between">
          <Link to="/">
            <img src={logo} alt="KGK Realty" className={`transition-all duration-300 ${scrolled ? 'h-16' : 'lg:h-16 h-16'}`} />
          </Link>
          <div className="hidden md:flex items-center gap-16 relative">
            <nav className="flex items-center space-x-10 text-white font-medium uppercase text-lg tracking-wider">
              {mainMenu.map((item) => item.dropdown ? (
                <div key={item.id} className="relative group">
                  <button className={`text-white px-3 pt-1 border-b-2 flex items-center gap-1 ${isActive('project') ? 'border-white' : 'border-transparent hover:border-white'}`}>
                    {item.label} <ChevronDown size={18} />
                  </button>
                  <div className="absolute top-[26px] px-3 py-3 left-0 mt-2 w-48 bg-black/95 backdrop-blur-md shadow-lg rounded-md hidden group-hover:block">
                    {item.dropdown.map((sub) => (
                      <div key={sub.id} className="relative group/sub">
                        <Link
                          to={sub.url}
                          className={`flex items-center justify-between px-4 py-2 text-sm rounded mb-1 ${isActive(sub.id) ? 'text-secondary bg-secondary/20' : 'text-white hover:bg-white/30'}`}
                        >
                          <span>{sub.label}</span>
                          {sub.subItems && <ChevronRight size={16} />}
                        </Link>
                        {sub.subItems && (
                          <div className="absolute left-full top-0 ml-1 w-40 bg-black/95 backdrop-blur-md shadow-lg rounded-md hidden group-hover/sub:block">
                            {sub.subItems.map((subItem) => (
                              <Link
                                key={subItem.id}
                                to={subItem.url}
                                className={`block px-4 py-2 text-sm rounded mb-1 ${isActive(subItem.id) ? 'text-secondary bg-secondary/20' : 'text-white hover:bg-white/30'}`}
                              >
                                {subItem.label}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <a key={item.id} href={item.url} className={`px-2 pt-1 border-b-2 ${isActive(item.id) ? 'text-white border-secondary font-semibold' : 'border-transparent hover:border-white text-white'}`}>
                  {item.label}
                </a>
              ))}
            </nav>
            <button className="bg-secondary text-white px-10 py-2 rounded font-bold text-md uppercase" onClick={() => setModalOpen(true)}>Enquire</button>
          </div>

          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
              {isOpen ? <X className="text-white h-6 w-6" /> : <Menu className="text-white h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* === Mobile Drawer === */}
        <div
          className={`fixed right-0 w-[70%] bg-black/90 backdrop-blur-sm shadow-md transform transition-transform duration-500 z-50 ${isOpen ? 'translate-x-0' : 'translate-x-full'
            }`}
          style={{
            top: `${headerHeight}px`,
            height: `calc(100vh - ${headerHeight}px)`
          }}
        >
          <div className="flex flex-col h-full overflow-y-auto px-4 pt-6 pb-6 text-white text-sm font-medium uppercase">
            {mainMenu.map((item) => item.dropdown ? (
              <React.Fragment key={item.id}>
                <button
                  onClick={() => setProjectOpen(!projectOpen)}
                  className="w-full text-left px-1 py-[14px] border-b border-white flex justify-between items-center"
                >
                  {item.label}
                  <ChevronDown className={`${projectOpen ? 'rotate-180' : ''} transition-transform duration-300`} size={18} />
                </button>
                <div className={`flex flex-col overflow-hidden transition-all duration-500 ease-in-out ${projectOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                  {item.dropdown.map((sub) => (
                    <React.Fragment key={sub.id}>
                      <div className="flex items-center justify-between">
                        <Link
                          to={sub.url}
                          onClick={() => setIsOpen(false)}
                          className={`flex-1 py-[14px] pl-4 border-b border-white ${isActive(sub.id) ? 'text-secondary' : 'text-white'} transition-opacity duration-300`}
                        >
                          {sub.label}
                        </Link>
                        {sub.subItems && (
                          <button
                            onClick={() => setResidentialOpen(!residentialOpen)}
                            className="px-2 pt-[14px] pb-[17px] border-b border-white"
                          >
                            <ChevronDown className={`${residentialOpen && sub.id === 'residential' ? 'rotate-180' : ''} transition-transform duration-300`} size={16} />
                          </button>
                        )}
                      </div>
                      {sub.subItems && sub.id === 'residential' && (
                        <div className={`flex flex-col overflow-hidden transition-all duration-500 ease-in-out ${residentialOpen ? 'max-h-32 opacity-100' : 'max-h-0 opacity-0'}`}>
                          {sub.subItems.map((subItem) => (
                            <Link
                              key={subItem.id}
                              to={subItem.url}
                              onClick={() => setIsOpen(false)}
                              className={`py-[14px] pl-6 border-b border-white text-sm ${isActive(subItem.id) ? 'text-secondary' : 'text-white'} transition-opacity duration-300`}
                            >
                              {subItem.label}
                            </Link>
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <a
                key={item.id}
                href={item.url}
                onClick={() => setIsOpen(false)}
                className={`block px-1 py-[14px] border-b border-white ${isActive(item.id) ? 'text-secondary' : 'text-white'}`}
              >
                {item.label}
              </a>
            ))}
            <button
              onClick={() => {
                setModalOpen(true);
                setIsOpen(false);
              }}
              className=" bg-secondary text-white px-6 py-2 rounded-full font-semibold text-sm uppercase mt-8"
            >
              Enquire
            </button>
          </div>
        </div>
      </header>

      {/* === Enquiry Modal === */}
      <EnquiryModalPopup  isOpen={modalOpen} onClose={() => setModalOpen(false)} />
      <FloatingActionButton />
    </>
  );
};

export default Navbar;